export const env = {
  apiUrl: "",
  production: false,
  accounting: "https://accounting-dev.es.mpu.gov.ua/accounting/v1",
  signWidgetUrl: "https://test.id.gov.ua/sign-widget/v2022testnew/",
  realmClientId: "estock-ui-client",
  realmUrl: "https://iam-dev.es.mpu.gov.ua/auth/realms/eStock",
  documentApi: "https://document-service-dev.es.mpu.gov.ua/v1",
  activeLocale: "uk",
  eStockHomePage: "https://estock-dev.es.mpu.gov.ua/",
  logisticsServiceBackend: "https://logistics-service-dev.es.mpu.gov.ua",
  // logisticsServiceBackend: "/api",
};
